import PageCustom from './page.vue';
import SimpleViewGrid from './simpleviewgrid.vue';
import SimpleTree from './simpletree.vue';
import RowBtnToolbar from './rowbtntoolbar.vue';
import DetailBtnToolbar from './detailbtntoolbar.vue';
import BillTemplate from './layouttemplate.vue';
export {RowBtnToolbar,PageCustom,SimpleViewGrid,DetailBtnToolbar,BillTemplate,SimpleTree};


// WEBPACK FOOTER //
// ./src/components/masterplate/index.js